import { Box, Text, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { ReactComponent as DesTooltipIcon } from '../../../../assets/des-tooltip-icon.svg';

const Field = (props) => {
  const {
    children,
    label,
    description,
    colorDes,
    isOptional,
    isShowTooltip = false,
    tooltipDes
  } = props;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleImageClick = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };

  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };

  return (
    <Box w={'full'}>
      {label && (
        <Text mb={'12px'} className="flex items-center gap-1">
          {label}{' '}
          {isOptional && (
            <Text as={'span'} color={'dim-gray'}>
              (optional)
            </Text>
          )}
          {isShowTooltip && (
            <Tooltip
              rounded="0.75rem"
              label={tooltipDes}
              placement={'top-start'}
              zIndex={0}
              bg="#E6E7EB"
              p={{ base: '10px', '2xl': '1rem' }}
              left={{ base: '120px', md: '0' }}
              fontSize={'xs'}
              color={'#333333'}
              isOpen={isTooltipOpen}
              transform={{
                base: 'translatex(-55%) !important',
                md: 'none !important'
              }}
            >
              <DesTooltipIcon
                cursor="pointer"
                className="w-[20px] h-[20px] z-0"
                alt=""
                onMouseEnter={() => handleMouseEnter('description')}
                onMouseLeave={() => handleMouseLeave('description')}
                onClick={() => handleImageClick('description')}
              />
            </Tooltip>
          )}
        </Text>
      )}

      {description && (
        <Text mb={'12px'} fontSize={'1rem'} color={colorDes ?? 'dim-gray'}>
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
};

export { Field };
